import * as React from 'react';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat, SeatPriceQuantity, SeatZone } from '../../classes/seat';
import { SeatingOption } from '../../classes/seating-option';
import AdditionalNotes from "../../common/notes/additional-notes";
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { ISeatMapModel } from '../reducers/seatmap-reducer';
import ConfirmPrompt from './confirm-prompt';
import SeatInfoNotice from './seat-info-error';
import SeatInfoHeaderContainer from './seat-info-header-container';
import SeatInfoImage from './seat-info-image';
import SeatInfoOptionsContainer from './seat-info-options-container';
import SeatInfoPrompts from './seat-info-prompts';
import SeatInfoPrices from './side-panel/seat-info-prices';
import { isPad } from '../../helpers/is-mobile';
import { checkSpecialSeatingSeatLimit } from '../actions/seatmap-actions';
import { ZoneUpsell } from '../../classes/zone-upsell';
import ZoneUpsellContainer from '../components/side-panel/zone-upsell-container';

export interface ISeatingInfoProps {
    appSettingsModel: IAppSettingsModel;
    cartSeats: Array<CartSeat>;
    selectedPriceTypes: Array<PriceType>;
    activeSeats: Array<Seat>;
    levelPricing: Array<SeatZone>;
    dispatch: any;
    viewFromSeatModalActive: boolean;
    maxQuantityPriceTypeError: boolean;
    minQuantityPriceTypeError: boolean;
    minQuantityPriceTypeSelectedErrorTextReplace: string;
    maxQuantitySeatingOptionError: boolean;
    flexQuantityPriceTypeError: boolean;
    flexMinQuantityError: boolean;
    flexMaxQuantityErrorAllTickets: boolean;
    flexMaxQuantityErrorPriceType: boolean;
    seatmapModel: ISeatMapModel;
    isGAZone?: boolean;
    isSingleClick: boolean;
    selectedSeatingOptions: SeatingOption[];
    hasConfirmPrompt: boolean;
    isExchange: boolean;
    isInCart: boolean;
    isSelectedSeat: boolean;
    onCancelConfirmClick: () => void;
    onConfirmSeatClick: () => void;
    onSelectPricing: (priceQuantities: Array<SeatPriceQuantity>) => void;
    onSelectSeatingOption: () => void;
    onSelectSeatClick: () => void;
    onSelectSeatDisabledClick: () => void;
    onSelectSeatInCartClick: () => void;
    onToggleSeatingInfoOpen: () => void;
    selectedPriceQuantities: SeatPriceQuantity[];
    needPriceTypeError: boolean;
    needSeatingOptionError: boolean;
    noMoreExchangeableTicketsError: boolean;
    selectedSeatsPreferenceUpdated: boolean;
    confirmPromptText: string;
    exchangeTicketsRemaining: number;
    additionalPurchasable: number;
    showSeatingInfo: boolean;
    selectedPriceTypeQuantities: Array<SeatPriceQuantity>;
    onCloseZoneUpsell: () => any;
    seats: Array<Seat>;
    zoneUpsell: ZoneUpsell;
    hidingUpsell: boolean;


}

class SeatingInfo extends React.Component<ISeatingInfoProps, null>{
    static defaultProps = {
        isGAZone: false,
    }

    render() {
        const {
            isSingleClick,
            hasConfirmPrompt,
            isInCart,
            isSelectedSeat,
            selectedPriceTypes,
            onSelectPricing,
            selectedPriceQuantities,

        } = this.props;
        const xSvg = `<svg class="close-filters-icon"><use xlink:href="#icon-close" /></svg>`;
        const useTag = `<title id="expandPromoCodeAltText">Toggle Selected Seat View</title><use xlink:href="#icon-arrow-down" />`;
        const showConfirmPrompt = (!isSingleClick && hasConfirmPrompt && isSelectedSeat && !isInCart);
        return (

            <div className={"seat-info-container"}>

                <div className="seat-info-container-header seat-info-container-header-desktop" onClick={this.props.onToggleSeatingInfoOpen}>

                    <h2 className="heading-general">{this.props.isGAZone ? this.props.appSettingsModel.seatmapSelectedZoneText : this.props.appSettingsModel.seatmapSelectedSeatText}</h2>

                </div>

                <div className="seat-info-container-header seat-info-container-header-mobile" onClick={this.props.onToggleSeatingInfoOpen}>
                    <svg className={"filters-section-heading-toggles-icon"} aria-labelledby="expandPromoCodeAltText" dangerouslySetInnerHTML={{ __html: useTag }} />

                    <h2 className="heading-general">{this.props.isGAZone ? this.props.appSettingsModel.seatmapSelectedZoneText : this.props.appSettingsModel.seatmapSelectedSeatText}</h2>

                </div>


                <div className={"seat-info-container-main"}>
                    {
                        showConfirmPrompt
                            ? this.renderConfirmPrompt()
                            : this.renderSeatingInfo()
                    }

                </div>

                <div className="seat-info-footer">
                    {
                        (this.props.activeSeats[0].tessituraSeat.isAvailable && !showConfirmPrompt) ?
                            <SeatInfoPrices
                                selectedPriceTypes={selectedPriceTypes}
                                onSelectPricing={onSelectPricing}
                                selectedPriceQuantities={selectedPriceQuantities}
                            />
                            : null
                    }

                    {
                        //!isSingleClick &&
                        this.props.activeSeats[0].tessituraSeat.isAvailable
                        && this.renderSelectButton()
                    }
                </div>


                {(!this.props.hidingUpsell) ?
                    <ZoneUpsellContainer {...this.props}
                        dispatch={this.props.dispatch}
                        appSettingsModel={this.props.appSettingsModel}
                        venueLevels={this.props.appSettingsModel.venueLevels}
                        zoneUpsell={this.props.zoneUpsell}
                        cartSeats={this.props.cartSeats}
                        seats={this.props.seats}
                        onCloseZoneUpsell={this.props.onCloseZoneUpsell}
                        selectedPriceTypeQuantities={this.props.selectedPriceTypeQuantities}
                    />
                    : null
                }

            </div>
        );
    }

    renderConfirmPrompt() {
        return <ConfirmPrompt appSettingsModel={this.props.appSettingsModel} confirmPromptText={this.props.confirmPromptText}
            onCancelSeatClick={this.props.onCancelConfirmClick}
            onConfirmSeatClick={this.props.onConfirmSeatClick} />
    }

    renderSeatingInfo() {
        const {
            isExchange,
            dispatch,
            levelPricing,
            activeSeats,
            appSettingsModel,
            selectedPriceTypes,
            onSelectPricing,
            onSelectSeatingOption,
            selectedPriceQuantities,
            selectedSeatingOptions,
            cartSeats,
            seatmapModel,
            flexQuantityPriceTypeError,
            needSeatingOptionError,
            needPriceTypeError,
            noMoreExchangeableTicketsError,
            exchangeTicketsRemaining,
            additionalPurchasable
        } = this.props;

        //if (isExchange) {
        //    return <ExchangeSeatInfo dispatch={dispatch} levelPricing={levelPricing}
        //        seat={this.props.activeSeats[0]}
        //        viewFromSeatModalActive={this.props.viewFromSeatModalActive}
        //        selectedPriceTypes={selectedPriceTypes}
        //        onSelectPricing={onSelectPricing}
        //        onSelectSeatingOption={onSelectSeatingOption}
        //        selectedPriceQuantities={selectedPriceQuantities}
        //        appSettingsModel={appSettingsModel}
        //        selectedSeatingOptions={selectedSeatingOptions}
        //        cartSeats={cartSeats}
        //        seatmapModel={seatmapModel}
        //        isInCart={this.props.isInCart}
        //    />
        //}

        return (
            <div className="seat-info-main">
                <div className="seat-info-top">
                    {
                        isPad() && this.props.appSettingsModel.disableMobileViewFromSeat ? null :
                            <SeatInfoImage
                                {...this.props}
                                loadingSeatView={seatmapModel.requestingSeatView}
                                seatViewImageSrc={this.props.activeSeats[0].seatViewImageSrc}
                                viewFromSeatModalActive={this.props.viewFromSeatModalActive}
                                altText={this.props.appSettingsModel.altText}
                                loadingSvgText={this.props.appSettingsModel.loadingSvgText}
                                loadingText={this.props.appSettingsModel.loadingText}
                                stopLoadingAnimationButtonText={this.props.appSettingsModel.stopLoadingAnimationButtonText}
                            />
                    }

                    <SeatInfoHeaderContainer seat={this.props.activeSeats[0]}
                        useZoneDescription={appSettingsModel.useZoneDescription}
                        isGAZone={this.props.isGAZone}
                    />
                </div>

                <SeatInfoNotice {...appSettingsModel}
                    {...this.props}
                    exchangeTicketsRemaining={exchangeTicketsRemaining}
                    additionalPurchasable={additionalPurchasable}
                    needPriceTypeError={needPriceTypeError}
                    needSeatingOptionError={needSeatingOptionError}
                    noMoreExchangeableTicketsError={noMoreExchangeableTicketsError}
                    showFlexPriceTypeError={flexQuantityPriceTypeError}
                    flexMaxQuantityError={this.props.flexMaxQuantityErrorAllTickets}
                    minQuantityPriceTypeError={this.props.minQuantityPriceTypeError}
                    minQuantityPriceTypeSelectedErrorTextReplace={this.props.minQuantityPriceTypeSelectedErrorTextReplace}
                    priceTypeMinQuantityRequiredMessage={this.props.appSettingsModel.minimumSeatsSingleTicketRequiredMessage}
                />
                {
                    this.props.activeSeats[0].tessituraSeat.isAvailable ?
                        <SeatInfoOptionsContainer {...this.props}
                            seat={this.props.activeSeats[0]}
                            onSelectSeatingOption={onSelectSeatingOption}
                            selectedSeatingOptions={selectedSeatingOptions}
                        />
                        : null
                }

            </div>
        );
    }

    get allPriceTypesMaxedOut() {
        const selectedPricings = [...this.props.selectedPriceQuantities.filter(pq => pq.quantity > 0)] as Array<SeatPriceQuantity>;

        return selectedPricings.every(selectedPricing => {
            let selectedPriceTypeMaxQuantity = this.props.appSettingsModel.priceTypeSettings.filter(pt => {
                return pt.priceTypeId === selectedPricing.seatPricing.priceTypeId;
            })[0].clientMaxQuantity;

            return (selectedPriceTypeMaxQuantity !== 0 && (selectedPricing.quantity > selectedPriceTypeMaxQuantity
                || this.props.cartSeats.filter(cs => cs.selectedPricing.priceTypeId == selectedPricing.seatPricing.priceTypeId).length >= selectedPriceTypeMaxQuantity))

        });
    }

    renderSelectButton() {
        if (this.props.hasConfirmPrompt && this.props.isSelectedSeat && !this.props.isInCart) {
            return null;
        }

        const cartButton = () => {
            const inCartMessage = this.props.isGAZone ? this.props.appSettingsModel.groupSeatsInCartMessage : this.props.appSettingsModel.seatIsInCartMessage;

            var specialSeatingCheck = checkSpecialSeatingSeatLimit(this.props.activeSeats[0], this.props.cartSeats);
            const cannotAddToCart = this.props.selectedPriceQuantities.length == 0 || this.allPriceTypesMaxedOut || this.props.needSeatingOptionError /*|| this.props.maxQuantityPriceTypeError*/
                || this.props.flexMaxQuantityErrorPriceType || !specialSeatingCheck;

            if (!this.props.isInCart) {
                return this.renderCartButton(this.props.appSettingsModel.addToCartButtonText, cannotAddToCart,
                    cannotAddToCart ? this.props.onSelectSeatDisabledClick : this.props.onSelectSeatClick);
            }
            if (this.props.selectedSeatsPreferenceUpdated) {
                return this.renderCartButton(this.props.appSettingsModel.updateCartButtonText, cannotAddToCart,
                    cannotAddToCart ? this.props.onSelectSeatDisabledClick : this.props.onSelectSeatClick);
            }

            return this.renderCartButton(this.props.appSettingsModel.viewCartButtonText, false,
                this.props.onSelectSeatInCartClick);
        }

        return (
            <div className="seat-info-select-container" onTouchMove={function (evt) { evt.preventDefault(); }}>
                {
                    this.props.isInCart ?
                        <p className="seat-info-container-cart-message">
                            {this.props.isGAZone ? this.props.appSettingsModel.groupSeatsInCartMessage : this.props.appSettingsModel.seatIsInCartMessage}
                        </p>
                        : null
                }
                {cartButton()}
            </div>
        );
    }

    renderCartButton(text: string, disabled: boolean, clickFunction: () => any) {
        return <button className={"seat-info-container-btn" + (disabled ? " disabled" : "")}
            onClick={clickFunction}>
            {text}
        </button>
    }
}

export default SeatingInfo;
